import { render } from "./GoogleIdentityCard.vue?vue&type=template&id=40d952fa&scoped=true"
import script from "./GoogleIdentityCard.vue?vue&type=script&lang=js"
export * from "./GoogleIdentityCard.vue?vue&type=script&lang=js"

import "./GoogleIdentityCard.vue?vue&type=style&index=0&id=40d952fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d952fa"]])

export default __exports__